import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export default definePreset(Aura, {
	semantic: {
		primary: {
			50: '{teal.50}',
			100: '{teal.100}',
			200: '{teal.200}',
			300: '{teal.300}',
			400: '{teal.400}',
			500: '{teal.500}',
			600: '{teal.600}',
			700: '{teal.700}',
			800: '{teal.800}',
			900: '{teal.900}',
			950: '{teal.950}'
		},
		colorScheme: {
			light: {
				primary: {
					color: '#00687a',
					inverseColor: '#ffffff',
					hoverColor: '#00586a',
					activeColor: '#00485a'
				},
				highlight: {
					background: 'rgba(0, 104, 122, 0.16)',
					focusBackground: 'rgba(0, 104, 122, 0.24)',
					color: 'rgba(0, 0, 0, 0.87)',
					focusColor: 'rgba(0, 0, 0, 0.87)'
				},
				surface: {
					0: '#ffffff',
					50: '{gray.50}',
					100: '{gray.100}',
					200: '{gray.200}',
					300: '{gray.300}',
					400: '{gray.400}',
					500: '{gray.500}',
					600: '{gray.600}',
					700: '{gray.700}',
					800: '{gray.800}',
					900: '{gray.900}',
					950: '{gray.950}'
				},
				formField: {
					background: '#ffffff',
					disabledBackground: '{surface.200}',
					filledBackground: '{surface.50}',
					filledHoverBackground: '{surface.50}',
					filledFocusBackground: '#ffffff',
					borderColor: '{surface.300}',
					hoverBorderColor: '{surface.400}',
					focusBorderColor: '{primary.color}',
					invalidBorderColor: '{red.400}',
					color: '{surface.700}',
					disabledColor: '{surface.500}',
					placeholderColor: '{surface.500}',
					floatLabelColor: '{surface.500}',
					floatLabelFocusColor: '{surface.500}',
					floatLabelActiveColor: '{surface.500}',
					floatLabelInvalidColor: '{red.400}',
					iconColor: '{surface.400}',
					shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)'
				}
			},
			dark: {
				primary: {
					color: '#4dd0e1',
					inverseColor: '#000000',
					hoverColor: '#67d8e7',
					activeColor: '#33c8db'
				},
				highlight: {
					background: 'rgba(77, 208, 225, 0.16)',
					focusBackground: 'rgba(77, 208, 225, 0.24)',
					color: 'rgba(255, 255, 255, 0.87)',
					focusColor: 'rgba(255, 255, 255, 0.87)'
				},
				surface: {
					0: '#000000',
					50: '{gray.950}',
					100: '{gray.900}',
					200: '{gray.800}',
					300: '{gray.700}',
					400: '{gray.600}',
					500: '{gray.500}',
					600: '{gray.400}',
					700: '{gray.300}',
					800: '{gray.200}',
					900: '{gray.100}',
					950: '{gray.50}'
				},
				formField: {
					background: '{surface.950}',
					disabledBackground: '{surface.700}',
					filledBackground: '{surface.800}',
					filledHoverBackground: '{surface.800}',
					filledFocusBackground: '{surface.950}',
					borderColor: '{surface.600}',
					hoverBorderColor: '{surface.500}',
					focusBorderColor: '{primary.color}',
					invalidBorderColor: '{red.300}',
					color: '{surface.0}',
					disabledColor: '{surface.400}',
					placeholderColor: '{surface.400}',
					floatLabelColor: '{surface.400}',
					floatLabelFocusColor: '{surface.400}',
					floatLabelActiveColor: '{surface.400}',
					floatLabelInvalidColor: '{red.300}',
					iconColor: '{surface.400}',
					shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.5)'
				}
			}
		}
	},
	components: {
		// Override specific component styles if needed
		button: {
			colorScheme: {
				light: {
					primary: {
						background: '#00687a',
						hoverBackground: '#00586a',
						activeBackground: '#00485a',
						borderColor: '#00687a',
						hoverBorderColor: '#00586a',
						activeBorderColor: '#00485a',
						color: '#ffffff',
						hoverColor: '#ffffff',
						activeColor: '#ffffff',
						focusRing: {
							color: 'rgba(0, 104, 122, 0.2)',
							shadow: '0 0 0 0.2rem rgba(0, 104, 122, 0.2)'
						}
					}
				},
				dark: {
					primary: {
						background: '#4dd0e1',
						hoverBackground: '#67d8e7',
						activeBackground: '#33c8db',
						borderColor: '#4dd0e1',
						hoverBorderColor: '#67d8e7',
						activeBorderColor: '#33c8db',
						color: '#000000',
						hoverColor: '#000000',
						activeColor: '#000000',
						focusRing: {
							color: 'rgba(77, 208, 225, 0.2)',
							shadow: '0 0 0 0.2rem rgba(77, 208, 225, 0.2)'
						}
					}
				}
			}
		},
		inputtext: {
			colorScheme: {
				light: {
					root: {
						background: '#ffffff',
						disabledBackground: '{surface.200}',
						filledBackground: '{surface.50}',
						filledHoverBackground: '{surface.50}',
						filledFocusBackground: '#ffffff',
						borderColor: '{surface.300}',
						hoverBorderColor: '{surface.400}',
						focusBorderColor: '#00687a',
						invalidBorderColor: '{red.400}',
						color: '{surface.700}',
						disabledColor: '{surface.500}',
						placeholderColor: '{surface.500}',
						shadow: '{formField.shadow}'
					}
				},
				dark: {
					root: {
						background: '{surface.950}',
						disabledBackground: '{surface.700}',
						filledBackground: '{surface.800}',
						filledHoverBackground: '{surface.800}',
						filledFocusBackground: '{surface.950}',
						borderColor: '{surface.600}',
						hoverBorderColor: '{surface.500}',
						focusBorderColor: '#4dd0e1',
						invalidBorderColor: '{red.300}',
						color: '{surface.0}',
						disabledColor: '{surface.400}',
						placeholderColor: '{surface.400}',
						shadow: '{formField.shadow}'
					}
				}
			}
		},
		select: {
			colorScheme: {
				light: {
					root: {
						background: '#ffffff',
						disabledBackground: '{surface.200}',
						borderColor: '{surface.300}',
						hoverBorderColor: '{surface.400}',
						focusBorderColor: '#00687a',
						invalidBorderColor: '{red.400}',
						color: '{surface.700}',
						disabledColor: '{surface.500}'
					},
					overlay: {
						background: '#ffffff',
						borderColor: '{surface.200}',
						color: '{surface.700}'
					},
					option: {
						focusBackground: '{surface.100}',
						selectedBackground: '{highlight.background}',
						selectedFocusBackground: '{highlight.focusBackground}',
						color: '{surface.700}',
						focusColor: '{surface.800}',
						selectedColor: '{highlight.color}',
						selectedFocusColor: '{highlight.focusColor}'
					}
				},
				dark: {
					root: {
						background: '{surface.950}',
						disabledBackground: '{surface.700}',
						borderColor: '{surface.600}',
						hoverBorderColor: '{surface.500}',
						focusBorderColor: '#4dd0e1',
						invalidBorderColor: '{red.300}',
						color: '{surface.0}',
						disabledColor: '{surface.400}'
					},
					overlay: {
						background: '{surface.900}',
						borderColor: '{surface.700}',
						color: '{surface.0}'
					},
					option: {
						focusBackground: '{surface.800}',
						selectedBackground: '{highlight.background}',
						selectedFocusBackground: '{highlight.focusBackground}',
						color: '{surface.0}',
						focusColor: '{surface.0}',
						selectedColor: '{highlight.color}',
						selectedFocusColor: '{highlight.focusColor}'
					}
				}
			}
		},
		multiselect: {
			colorScheme: {
				light: {
					root: {
						background: '#ffffff',
						disabledBackground: '{surface.200}',
						borderColor: '{surface.300}',
						hoverBorderColor: '{surface.400}',
						focusBorderColor: '#00687a',
						invalidBorderColor: '{red.400}',
						color: '{surface.700}',
						disabledColor: '{surface.500}'
					},
					overlay: {
						background: '#ffffff',
						borderColor: '{surface.200}',
						color: '{surface.700}'
					},
					option: {
						focusBackground: '{surface.100}',
						selectedBackground: '{highlight.background}',
						selectedFocusBackground: '{highlight.focusBackground}',
						color: '{surface.700}',
						focusColor: '{surface.800}',
						selectedColor: '{highlight.color}',
						selectedFocusColor: '{highlight.focusColor}'
					}
				},
				dark: {
					root: {
						background: '{surface.950}',
						disabledBackground: '{surface.700}',
						borderColor: '{surface.600}',
						hoverBorderColor: '{surface.500}',
						focusBorderColor: '#4dd0e1',
						invalidBorderColor: '{red.300}',
						color: '{surface.0}',
						disabledColor: '{surface.400}'
					},
					overlay: {
						background: '{surface.900}',
						borderColor: '{surface.700}',
						color: '{surface.0}'
					},
					option: {
						focusBackground: '{surface.800}',
						selectedBackground: '{highlight.background}',
						selectedFocusBackground: '{highlight.focusBackground}',
						color: '{surface.0}',
						focusColor: '{surface.0}',
						selectedColor: '{highlight.color}',
						selectedFocusColor: '{highlight.focusColor}'
					}
				}
			}
		},
		calendar: {
			colorScheme: {
				light: {
					root: {
						background: '#ffffff',
						disabledBackground: '{surface.200}',
						borderColor: '{surface.300}',
						hoverBorderColor: '{surface.400}',
						focusBorderColor: '#00687a',
						invalidBorderColor: '{red.400}',
						color: '{surface.700}',
						disabledColor: '{surface.500}',
						placeholderColor: '{surface.500}'
					},
					panel: {
						background: '#ffffff',
						borderColor: '{surface.200}',
						color: '{surface.700}'
					},
					header: {
						background: '#ffffff',
						borderColor: '{surface.200}',
						color: '{surface.700}'
					},
					dayLabel: {
						color: '{surface.500}'
					},
					weekDay: {
						color: '{surface.700}'
					},
					date: {
						hoverBackground: '{surface.100}',
						color: '{surface.700}',
						hoverColor: '{surface.800}',
						otherMonthColor: '{surface.400}',
						todayColor: '#00687a',
						selectedBackground: '#00687a',
						selectedColor: '#ffffff'
					}
				},
				dark: {
					root: {
						background: '{surface.950}',
						disabledBackground: '{surface.700}',
						borderColor: '{surface.600}',
						hoverBorderColor: '{surface.500}',
						focusBorderColor: '#4dd0e1',
						invalidBorderColor: '{red.300}',
						color: '{surface.0}',
						disabledColor: '{surface.400}',
						placeholderColor: '{surface.400}'
					},
					panel: {
						background: '{surface.900}',
						borderColor: '{surface.700}',
						color: '{surface.0}'
					},
					header: {
						background: '{surface.900}',
						borderColor: '{surface.700}',
						color: '{surface.0}'
					},
					dayLabel: {
						color: '{surface.400}'
					},
					weekDay: {
						color: '{surface.0}'
					},
					date: {
						hoverBackground: '{surface.800}',
						color: '{surface.0}',
						hoverColor: '{surface.0}',
						otherMonthColor: '{surface.500}',
						todayColor: '#4dd0e1',
						selectedBackground: '#4dd0e1',
						selectedColor: '#000000'
					}
				}
			}
		},
		datatable: {
			colorScheme: {
				light: {
					root: {
						borderColor: '{surface.300}'
					},
					header: {
						background: '{surface.50}',
						borderColor: '{surface.300}',
						color: '{surface.700}'
					},
					headerCell: {
						background: '{surface.50}',
						borderColor: '{surface.300}',
						color: '{surface.700}',
						hoverBackground: '{surface.100}',
						hoverColor: '{surface.800}'
					},
					row: {
						background: '#ffffff',
						stripedBackground: '{surface.50}',
						color: '{surface.700}',
						hoverBackground: '{surface.100}',
						hoverColor: '{surface.800}'
					},
					bodyCell: {
						borderColor: '{surface.300}'
					},
					footerCell: {
						background: '{surface.50}',
						borderColor: '{surface.300}',
						color: '{surface.700}'
					},
					footer: {
						background: '{surface.50}',
						borderColor: '{surface.300}',
						color: '{surface.700}'
					}
				},
				dark: {
					root: {
						borderColor: '{surface.600}'
					},
					header: {
						background: '{surface.800}',
						borderColor: '{surface.600}',
						color: '{surface.0}'
					},
					headerCell: {
						background: '{surface.800}',
						borderColor: '{surface.600}',
						color: '{surface.0}',
						hoverBackground: '{surface.700}',
						hoverColor: '{surface.0}'
					},
					row: {
						background: '{surface.900}',
						stripedBackground: '{surface.950}',
						color: '{surface.0}',
						hoverBackground: '{surface.800}',
						hoverColor: '{surface.0}'
					},
					bodyCell: {
						borderColor: '{surface.600}'
					},
					footerCell: {
						background: '{surface.800}',
						borderColor: '{surface.600}',
						color: '{surface.0}'
					},
					footer: {
						background: '{surface.800}',
						borderColor: '{surface.600}',
						color: '{surface.0}'
					}
				}
			}
		}
	}
})
